import { HttpStatus } from '../../constant/responseStatus';
import { useEffect, useState } from 'react';
import { SearchRequestModel } from 'src/models/assetModel';
import { AssetService } from 'src/services/assetService';
import assetSearchModel from 'src/models/responses/assetSearchModel';
import GallerySearch from '../gallerySearch/GallerySearch';
import TranslationKey from 'src/i18n/translation';
import EmptyBox from '../empty/EmptyBox';

interface TypeInterface {
  assetId: string;
  keywords: string[] | undefined;
}

export default function GallerysMoreLikeThis({ assetId, keywords }: TypeInterface) {
  const [assets, setAssets] = useState<assetSearchModel[]>([]);
  const [params, setParams] = useState('');

  useEffect(() => {
    if (!keywords || keywords?.toString() == params) {
      return;
    }

    setParams(keywords.toString());
    onGetRandomAssetAsync();
  }, [keywords]);

  const onGetRandomAssetAsync = async () => {
    const request: SearchRequestModel = {
      search: undefined,
      keywords: keywords ? keywords : undefined,
      colors: undefined,
      artist: undefined,
      orientation: undefined,
      assetType: undefined,
      assetUsage: undefined,
    };

    const {
      data: responseData,
      status: responseStatus
    } = await new AssetService().getSimilarAssets(request, 1, 15);

    if (responseStatus !== HttpStatus.OK) {
      setAssets([]);
      return;
    }

    if (responseData.data.length === 0) {
      setAssets([]);
      return;
    }

    const resultExcludeMainAsset =
      responseData.data.filter((asset) => asset.id !== assetId)

    if (resultExcludeMainAsset.length === 0) {
      setAssets([]);
      return;
    }

    setAssets(resultExcludeMainAsset);
  };

  return (
    <>
      <h1 className='text-light'>
        {TranslationKey('assetDetail.moreLikeThis')}
      </h1>
      {
        assets.length === 0
          ? <EmptyBox />
          : <></>
      }
      <div className='box-gallery'>
        <div className='gallery'>
          <GallerySearch searchModel={assets} />
          <div className='box-gradient' />
          <div className='box-gradient-end' />
        </div>
        <div className='view-all'>
          {
            params.length > 0
              ?
              <a className='text-light'
                href={`/search?k=${params}`}>
                {TranslationKey('home.viewAll')}
              </a>
              :
              <a className='text-light'
                href='/search'>
                {TranslationKey('home.viewAll')}
              </a>
          }
        </div>
      </div>
    </>
  )
}
